import { C8AttributeId } from "src/c8-platform/type/node";
import ReflectionAttribute from "./ReflectionAttribute";
import ReflectionClass from "./ReflectionClass";
import { getClassAttribute } from "./reflectionData";
import { DomainAttributeData, IReflectionDomainAttribute } from "./reflectionTypes";

export default class ReflectionDomainAttribute implements IReflectionDomainAttribute {
	readonly domainId: C8AttributeId;
	readonly rca: ReflectionAttribute;
	readonly secondaryId: C8AttributeId;

	constructor(data: DomainAttributeData, primaryClass: ReflectionClass, secondaryMap: Record<string, ReflectionClass>) {
		if (data[1]) {
			this.secondaryId = data[1];
		}

		this.domainId = data[0];
		this.rca = getClassAttribute(secondaryMap[this.secondaryId] || primaryClass, data[2] || this.domainId);
	}
}
